import React from 'react'
import PropTypes from 'prop-types'

import './TextInput.scss'

const TextInput = ({ id, label, type, placeholder, suggestion, inputRef,
  disabled, value, onChange, onFocus, name, className, ...props }) => {
  const classes = className

  return (
    <div className={`text-input ${classes}`}>
      {
        label &&
        <label htmlFor={id || name}>{label}</label>
      }
      <input
        ref={inputRef}
        type={type}
        placeholder={placeholder}
        id={id || name}
        value={value}
        name={name}
        disabled={disabled}
        onChange={onChange}
        onFocus={onFocus}
        {...props}
      />
      {/*
        suggestion &&
        <div
          className="text-input-suggest"
          onClick={suggestion.onClick}
        >
          <p>{suggestion.text}</p>
        </div>
      */}
    </div>
  )
}

TextInput.defaultProps = {
  type: 'text',
  id: '',
  className: '',
  name: '',
  label: '',
  placeholder: '',
  value: '',
  disabled: false,
  onChange: null,
  onFocus: null,
  suggestion: null,
}

TextInput.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  suggestion: PropTypes.any,
}

export default TextInput



// WEBPACK FOOTER //
// ./src/browser/components/fields/TextInput.js